import React, { useCallback, useState } from 'react';
import { JSX } from '@ionic/core/components';
import { CustomCropper, CustomIonModal, ModalContainer, StyledModalButton } from './CropperModal.style';

type CropperModalProps = {
  imageLink?: any;
  setImageFile: (file: File) => void;
  onDidDismiss: () => void;
  onSubmit?: () => void;
} & JSX.IonModal;

const CropperModal: React.FC<CropperModalProps> = ({ imageLink, setImageFile, onDidDismiss, ...props }) => {
  const [cropper, setCropper] = useState<Cropper | null>(null);

  const saveCropResult = useCallback(() => {
    if (cropper) {
      cropper
        .getCroppedCanvas({
          maxWidth: 1280,
          maxHeight: 1280,
          minWidth: 256,
          minHeight: 256,
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high',
        })
        .toBlob((file) => file && setImageFile(new File([file], 'avatar')), 'image/jpeg', 1);
      onDidDismiss();
    }
  }, [cropper]);

  return (
    <CustomIonModal {...props} onDidDismiss={onDidDismiss}>
      <ModalContainer>
        <CustomCropper
          style={{ height: '100%', width: '100%' }}
          className={'gap-10px'}
          src={imageLink ?? ''}
          onInitialized={(instance) => {
            setCropper(instance);
          }}
          zoomable={false}
          draggable={false}
          guides={false}
          minCropBoxHeight={100}
          minCropBoxWidth={100}
          aspectRatio={1 / 1}
          movable={false}
          center={true}
          background={false}
        />
      </ModalContainer>
      <StyledModalButton buttonType={'primary'} onClick={saveCropResult} style={{ margin: 0 }}>
        Підтвердити
      </StyledModalButton>
    </CustomIonModal>
  );
};

export default CropperModal;
